module.exports = __webpack_public_path__ + "static/img/robot-x1.c0f0304.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/robot-x1.png
// module id = GeD7
// module chunks = 1